<template>
  <ul class="nav nav-mobile-menu">
    <li class="nav-item">
      <button class="nav-link" @click="logOut">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 48 48">
          <g transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"><g>
            <path d="M9.5,10v2.5a1,1,0,0,1-1,1h-7a1,1,0,0,1-1-1V1.5a1,1,0,0,1,1-1h7a1,1,0,0,1,1,1V4" style="fill: none;stroke: white;stroke-linecap: round;stroke-linejoin: round"></path>
            <line x1="12.5" y1="7" x2="4.5" y2="7" style="fill: none;stroke: white;stroke-linecap: round;stroke-linejoin: round"></line>
            <polyline points="6.5 5 4.5 7 6.5 9" style="fill: none;stroke: white;stroke-linecap: round;stroke-linejoin: round"></polyline>
          </g></g>
        </svg>
      
        <span>Log out</span>
      </button>
    </li>
  </ul>
</template>
<script>

import FormDropdown from "/src/components/FormDropdown.vue"

export default {
  components: {
    FormDropdown,
  },
  methods: {
    async logOut() {
      this.$logout()
    },
  },
}
  
</script>

<style scoped>

.nav-link, .nav-mobile-menu {
  padding: 0px !important;
  margin: 0px !important;
}

.nav-link {
  padding: 8px 0px !important;
  text-transform: none !important;
  font-weight: 400 !important;
  font-size: 0.75rem !important;
  line-height: 1.25rem !important;
}

.nav-item {
  padding: 0px 4px;
  margin-left: 15px;
}

svg {
  margin-right: 11px;
}

</style>
